import { useEffect, useState } from "react";
import { Modal, Form, FormGroup, Input, Alert, Button } from "reactstrap";
import AppSpinner from "../../elements/AppSpinner";

const ModifyVariableValueModal = ({
  open,
  onClose,
  submitting,
  error,
  onSave,
  listValue = null,
  listName,
  startingType,
}) => {
  const [name, setName] = useState("");
  const [type, setType] = useState(startingType || "");
  const [value, setValue] = useState("");

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleTypeChange = (e) => {
    setValue("");
    setType(e.target.value);
  };

  const handleValueChange = (e) => {
    if (listValue) return;

    setValue(e.target.value);
  };

  const handleCheckboxChange = (e) => {
    const newValue = e.target.checked;

    setValue(newValue);
  };

  const handleExisitingValue = (listValue) => {
    setName(listValue.Name);
    setType(listValue.Type);
    setValue(listValue.Value);
  };

  const handleSave = (e) => {
    e.preventDefault();

    const payload = {
      Name: name,
      Value: value,
      Type: type,
      _ModuleAPIName: listName,
      _ModuleType: "Global-Lists",
      ...(listValue?.id && { id: listValue.id }),
    };

    onSave(payload);
  };

  const handleClose = () => {
    onClose();
    resetModal();
  };

  const resetModal = () => {
    setName("");
    setType(startingType || "");
    setValue("");
  };

  useEffect(() => {
    if (listValue !== null) {
      handleExisitingValue(listValue);
    } else {
      resetModal();
    }
  }, [listValue, open]);

  useEffect(() => {
    if (!open) {
      resetModal();
    }
  }, [open]);

  return (
    <Modal className="modal-dialog-centered" isOpen={open} toggle={handleClose}>
      <div className="modal-header">
        <h5 className="modal-title">
          {listValue ? "Modify Value" : "Add Value"}
        </h5>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={handleClose}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <Form onSubmit={handleSave}>
        <div className="modal-body">
          <FormGroup>
            <h5>Name</h5>
            <Input
              placeholder="Name"
              type="text"
              value={name}
              onChange={handleNameChange}
            />
          </FormGroup>

          <FormGroup>
            <h5>Type</h5>
            <Input
              placeholder="Type"
              type="select"
              value={type}
              onChange={handleTypeChange}
            >
              <option disabled={true} value="">
                Select A Type
              </option>
              <option value="string">String</option>
              <option value="int">Integer</option>
              <option value="float">Float</option>
              <option value="boolean">Boolean</option>
              <option value="object">JSON Object</option>
            </Input>
          </FormGroup>
          {(type === "string" || type === "object") && (
            <FormGroup>
              <h5>Value {type === "object" ? " (JSON)" : ""}</h5>
              <Input
                placeholder="Value"
                type="textarea"
                value={value}
                onChange={handleValueChange}
                readOnly={listValue !== null}
              />
            </FormGroup>
          )}
          {type === "int" && (
            <FormGroup>
              <h5>Value</h5>
              <Input
                placeholder="Value"
                type="tel"
                value={value}
                onChange={handleValueChange}
              />
            </FormGroup>
          )}

          {type === "float" && (
            <FormGroup>
              <h5>Value</h5>
              <Input
                placeholder="Value"
                type="text"
                value={value}
                onChange={handleValueChange}
              />
            </FormGroup>
          )}

          {type === "boolean" && (
            <FormGroup>
              <h5>Value</h5>
              <label className="custom-toggle">
                <input
                  onClick={handleCheckboxChange}
                  value={value}
                  type="checkbox"
                />
                <span
                  className="custom-toggle-slider rounded-circle"
                  data-label-off="F"
                  data-label-on="T"
                />
              </label>
            </FormGroup>
          )}

          {error && (
            <Alert color="warning" className="mt-3 mb-0">
              {error}
            </Alert>
          )}
        </div>
        <div className="modal-footer">
          <Button
            color="secondary"
            data-dismiss="modal"
            type="button"
            onClick={handleClose}
          >
            Close
          </Button>
          <Button
            color="primary"
            type="submit"
            disabled={submitting || !name || !type}
          >
            {submitting ? (
              <AppSpinner
                color="white"
                style={{ color: "#FFF", height: "20px", className: "px-3" }}
              />
            ) : (
              <>Save</>
            )}
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default ModifyVariableValueModal;
